import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { toRem } from 'design';
import { Logo } from '../Logo';

const LOGO_HEIGHT = 27.5;

const Layout = styled.div`
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  width: ${toRem(66)};
  height: ${toRem(66)};
`;

const StyledLogo = styled(Logo)`
  width: ${toRem(LOGO_HEIGHT)};
`;

const HeaderLogo: React.FC = () => (
  <Layout>
    <Link to="/">
      <StyledLogo />
    </Link>
  </Layout>
);

export default HeaderLogo;
